import type { JSX } from "react";

export const AnalyticsLoadingState = (): JSX.Element => {
  return (
    <div className="flex min-h-80 flex-1 items-center justify-center rounded-xl border border-(--border-color) bg-(--bg-light) px-6 py-12">
      <div className="flex flex-col items-center gap-4 text-center">
        <span className="inline-flex h-11 w-11 animate-spin rounded-full border-[3px] border-[rgba(148,163,184,0.24)] border-t-(--primary-color)" />
        <p className="text-[0.95rem] text-(--text-secondary)">
          Loading analytics data...
        </p>
      </div>
    </div>
  );
};
